import React from 'react';
import type { Contact } from '../../types/contact';
import ContactCard from './ContactCard';

interface ContactGridViewProps {
  contacts: Contact[];
}

export default function ContactGridView({ contacts }: ContactGridViewProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {contacts.map((contact) => (
        <ContactCard key={contact.id} contact={contact} />
      ))}
    </div>
  );
}